import styled from 'styled-components';
import {
  Link,
} from 'react-router';

import {
  Flex,
} from 'web-styled';

export const Item = styled(Flex).attrs({
  column: true,
})`
  margin: 0;
  width: 100%;
  padding: 15px;
  border-bottom: 1px solid #ededed;

  & .is_hover_only {
    visibility: hidden;
  }

  &:hover {
    background: #fbfbfb;

    & .is_hover_only {
      visibility: visible;
    }
  }
`;

export const Name = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  color: ${props => props.theme.colors.link};
  font-size: 14px;
  text-overflow: ellipsis;
  line-height: 30px;

  & > svg {
    margin-left: 0px;
    margin-right: 10px;
  }
`;

export const Time = styled.span`
  color: #404447;
  font-size: 14px;
  line-height: 30px;
`;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
`;
